














import Vue from 'vue'
import Component from "vue-class-component";
import { CollapseTransition } from "vue2-transitions";

@Component({components: {CollapseTransition}})
export default class SpoilerWings extends Vue {
  private show = false
}
